export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-04.jpg'),
        title: '人工智能',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '拥抱AI就是拥抱未来',
      description: `<p style="font-size:1.05rem">人工智能正在引领全球公司的创新。 人工智能是教授计算机如何进行只有人们过去可以做的智能工作的领域，例如模拟人类思维过程和智能行为：学习，推理和思考等。
机器学习和深度学习通过计算机操作从概念走向现实; 在现代，人工智能在语音和图像处理领域取得了很大进步。
</p>`
    },
    {
      title: '我们的优势',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-04.jpg')+`)"></span>
      <span>Maesinfo拥有高水平的机器学习和深度学习工程师和博士学位。 来自一流大学的教授，研究尖端技术并将其应用于许多领域，例如：医学成像，语言翻译，儿童教育，图像识别等，为您的企业提供专业的人工智能解决方案。 为您的企业使用人工智能解决方案将帮助您降低劳动力成本，提高业务运营的效率和准确性。</span>`
    }
  ]
}
